import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { InfluencerCampaignStatus } from '../../../models/influencer-campaign';
import { CommonConstant, CampaignInfluencerStatus, ChannelStatus } from '../../app.constants';
import { CampaignService } from '../../services/campaign/campaign.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {InfluencerService} from '../../services/influencer/influencer.service';
import { NewCampaignTabs } from '../../../models/campaign';
import {Conversation, Message} from '../../../models/inbox';
import { Observable } from 'rxjs/Observable';
import {Location} from '@angular/common';
import {CommunicationService} from '../../services/communication/communication.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {PdfViewerService} from '../pdf-viewer/pdf-viewer.service';
import {ModalService} from '../../services/modal/modal.service';
import {AppSettings} from '../../utils/app-settings';
import {InfluencerInfo, RequestInfluencerType} from '../../../models/influencer';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  ActionDetails, ActionSource,
  EventTrackerService, Page, TargetType,
  UserActionType
} from '../../services/event-tracker/event-tracker.service';
import {TranslateService} from '@ngx-translate/core';
import * as Sentry from '@sentry/browser';
import {InfluencerRequestError} from '../../influencer-platform/influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component';
import {InfluencerStatus} from '../../../models/influencer/new-influencer';
import {AuthService} from '../../core/auth.service';

@Component({
  selector: 'campaign-new',
  templateUrl: './campaign-new.component.html',
  styleUrls: ['./campaign-new.component.scss']
})
export class CampaignNewComponent implements OnInit, OnDestroy {
  @ViewChild('AlertPdfDownloadPending')
  public alertPdfDownloadPending: AchooPopupComponent;
  @ViewChild('WarningFailToRetrieveCampaign')
  warningFailToRetrieveCampaign: AchooPopupComponent;

  errorType: InfluencerRequestError;

  private slider: InfluencerCampaignStatus[];
  public campaignSlider: InfluencerCampaignStatus[];
  public campaign: any;
  private campaignId: number;
  private campaignInfluencerId: number;
  public selectedTab: NewCampaignTabs = NewCampaignTabs.CAMPAIGN;
  public showActivityLog = true;
  public conversation: Conversation;
  private campaignInfluencer: any;
  private campaignInfluencerOriginalStatus: any;
  private inviteToken;
  private isNewCampaign: boolean;
  private isFirstTime: boolean;
  private currentInfluencer: InfluencerInfo;
  private isReAccept: boolean;
  public isDeletedOrError: boolean;

  constructor(public newCampaignService: CampaignService,
              private influencerService: InfluencerService,
              private communicationService: CommunicationService,
              private pdfViewerService: PdfViewerService,
              private modalService: ModalService,
              private router: Router,
              private location: Location,
              private activatedRoute: ActivatedRoute,
              private userService: UserService,
              private eventTracker: EventTrackerService,
              private deviceService: DeviceDetectorService,
              private auth: AuthService) {
    this.slider = [
      {i: 0, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name, selected: false},
      {i: 1, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name, selected: false},
      {i: 2, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name, selected: false},
      {i: 3, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name, selected: false}
    ];
    this.updateSlider('');
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.campaignId = Number(params.campaignId);
    });
    this.activatedRoute.queryParams.subscribe((qp) => {
      this.isNewCampaign = qp.isNewCampaign;
      if (qp.inviteToken && AppSettings.isActiveNewCampaignFlow()) {
        this.inviteToken = qp.inviteToken;
        this.hideSideBar();
      }
      if (qp.isReAccept) {
        this.isReAccept = Boolean(qp.isReAccept);
      }
    });
    this.currentInfluencer = this.userService.getInfluencerInfo();
    if (this.currentInfluencer) {
      this.retrieveCampaignInvitationData(this.currentInfluencer, this.campaignId, this.deviceService.isMobile());
      this.checkInfluencerStatus(this.currentInfluencer);
    } else {
      this.showErrorPopup(InfluencerRequestError.CAMPAIGN_INVITATION_DELETE);
      this.sendMixpanelEvent(ActionDetails.INFLUENCER_REQUEST_DELETE);
    }
  }

  ngOnDestroy() {
    if (AppSettings.isActiveNewCampaignFlow()) {
      this.showSideBar();
    }
  }

  private checkInfluencerStatus(influencer: InfluencerInfo) {
    if (influencer.isActive === InfluencerStatus.INACTIVE || influencer.isActive === InfluencerStatus.DELETED) {
      this.influencerService.activeInfluencer(influencer.id).subscribe();
    }
  }

  private checkInfluencerConfirmation(influencer: InfluencerInfo) {
    if (influencer && !influencer.acceptedTermService) {
      this.auth.needAcceptedTermAndCondition();
    }
  }

  private retrieveCampaignInvitationData(influencer, campaignId, isMobile) {
    this.newCampaignService.getCampaignOfInfluencer(influencer.id, campaignId).subscribe((res1) => {
      if (this.isCampaignInvitationExisted(res1, influencer.id, campaignId)) {
        // check whether the influencer is confirmed
        this.checkInfluencerConfirmation(this.currentInfluencer);
        // Campaign influencer
        const campaignInfluencer = this.campaignInfluencer = res1[0];
        if (this.isReAccept) {
          campaignInfluencer.status = CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name.toLowerCase();
        } else {
          campaignInfluencer.status = campaignInfluencer.status;
        }
        this.campaignInfluencerOriginalStatus = campaignInfluencer.status;
        campaignInfluencer.status = this.calculateCampaignStatus(campaignInfluencer.status);
        this.campaignInfluencerId = campaignInfluencer.campaign_influencer_id;

        // Slider
        this.updateSlider(this.campaignInfluencerOriginalStatus.toUpperCase());
        if ((campaignInfluencer.status === CampaignInfluencerStatus.DELETE || campaignInfluencer.status === CampaignInfluencerStatus.ACTIVE) && !isMobile) {
          const actionDetail = campaignInfluencer.status === CampaignInfluencerStatus.DELETE ? ActionDetails.INFLUENCER_DECLINED_REQUEST : ActionDetails.INFLUENCER_ACCEPTED_REQUEST;
          this.sendMixpanelEvent(actionDetail, campaignInfluencer.campaign_id, campaignInfluencer.campaign_name);
          return this.router.navigate(['dashboard', 'campaigns', this.campaignInfluencer.campaign_influencer_id, 'active']);
        }
        this.getCampaignDetailData(campaignId, this.campaignInfluencer);
      } else {
        if (AppSettings.isActiveNewCampaignFlow()) {
          this.showErrorPopup(InfluencerRequestError.CAMPAIGN_INVITATION_DELETE);
        } else {
          this.router.navigate(['dashboard', 'campaigns']);
        }
        this.isDeletedOrError = true;
        this.sendMixpanelEvent(ActionDetails.INFLUENCER_REQUEST_DELETE);
      }
    }, (err) => {
      this.isDeletedOrError = true;
      this.showErrorPopup(InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL);
    });
  }

  private getCampaignDetailData(campaignId, campaignInfluencer) {
    this.newCampaignService.getCampaign(campaignId, campaignInfluencer.campaign_company_id).subscribe((res) => {
      // Campaign
      this.normalizeCampaignData(res, campaignInfluencer.status);
      // send MP event
      const actionDetail = this.getMPActionDetail();
      this.sendMixpanelEvent(actionDetail, this.campaign.campaign.id, this.campaign.campaign.name);
      // if campaign is archived, redirect to platform mode
      if (this.campaign.campaign.status === CampaignInfluencerStatus.ARCHIVED) {
        this.router.navigate(['dashboard', 'campaigns', campaignInfluencer.campaign_influencer_id, 'active']);
      }
    }, (err) => {
      if (err.error && err.error.data === 'campaign_not_found') {
        return Observable.of(null);
      } else {
        this.isDeletedOrError = true;
        this.showErrorPopup(InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL);
      }
    });
  }

  private getMPActionDetail() {
    let actionDetail;
    if (this.campaign.campaign.status === CampaignInfluencerStatus.ARCHIVED) {
      actionDetail = ActionDetails.INFLUENCER_CAMPAIGN_ARCHIVED;
    } else if (this.campaignInfluencer.status === CampaignInfluencerStatus.NEW) {
      actionDetail = ActionDetails.INFLUENCER_OPEN_REQUEST;
    } else if (this.campaignInfluencerOriginalStatus.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()) {
      actionDetail = ActionDetails.INFLUENCER_ACCEPTED_REQUEST;
    } else if (this.campaignInfluencerOriginalStatus.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name.toLowerCase()) {
      actionDetail = ActionDetails.INFLUENCER_DECLINED_REQUEST;
    }
    return actionDetail;
  }

  private showErrorPopup(errorType: InfluencerRequestError) {
    this.errorType = errorType;
    this.modalService.openInCenter(this.warningFailToRetrieveCampaign,
      this.onDismissCampaignErrorModal.bind(this),
      'fail-retrieve-camp', true);
  }

  private sendMixpanelEvent(actionDetails, campaignId?, campaignName?, isAcceptOrRejectRequest?) {
    let target = {
      type: TargetType.CAMPAIGN
    };
    if (campaignId && campaignName) {
      target = Object.assign({}, target, {
        id: campaignId,
        name: campaignName,
      });
    }
    if (!isAcceptOrRejectRequest) {
      this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN_INVITATION, target, {
        actionDetails: actionDetails,
        source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
        campaignId: campaignId
      }, undefined, null);
    } else {
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN_INVITATION, target, {
        actionDetails: actionDetails,
        source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
        campaignId: campaignId,
        action: UserActionType.UPDATE
      }, undefined, null);
    }
  }

  private hideSideBar() {
    document.body.classList.add('no-sidebar');
  }

  private showSideBar() {
    document.body.classList.remove('no-sidebar');
  }

  private isCampaignInvitationExisted(campaignInfluencers: any[], influencerId: number, campaignId: number) {
    if (!Array.isArray(campaignInfluencers) || campaignInfluencers.length === 0) {
      return false;
    }
    return campaignInfluencers.findIndex(ci => ci.campaign_id === campaignId && ci.influencer_id === influencerId) >= 0;
  }

  private loadInfluencerConversation(campaignCompany: number, influencerId: number) {
    this.communicationService.fetchInfluencerConversation(campaignCompany, influencerId).subscribe((res) => {
      this.conversation = res;
    });
  }

  private updateSlider(status: string) {
    this.campaignSlider = this.slider.slice(0); // Clone to new array
    this.campaignSlider.forEach(item => {
      item.selected = item.name === status;
    });
  }

  private normalizeCampaignData(campaignData, status) {
    const additionalInformation = {
      content: campaignData.campaign.additionalInfo
    };
    const uploadMaterials = campaignData.files.map(f => ({
      image: f.fileUrl,
      name: f.fileName,
      id: f.id,
      contentType: f.contentType
    }));
    const selectedTerms = campaignData.terms.map(st => ({
      id: st.id,
      summary: st.termSummary.content
    }));
    this.campaign = {
      campaign: campaignData.campaign,
      influencerStatus: status,
      selectedTerms,
      additionalInformation,
      uploadMaterials
    };
  }

  onAcceptCampaign() {
    this.goToAllSetPage(true, true);
    this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name).then((success) => {
      this.updateSlider(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name);
      this.sendMixpanelEvent(ActionDetails.INFLUENCER_ACCEPTED_REQUEST, this.campaign.campaign.id, this.campaign.campaign.name, true);
    }, (error) => {
      // Report to Sentry
      Sentry.captureException(error);
      return this.goToAllSetPage(true, false);
    });
  }

  onDeclineCampaign(isFirstTime?: boolean) {
    this.isFirstTime = isFirstTime;
    if (isFirstTime) {
      this.goToAllSetPage(false, null, true);
    }
    this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name).then((success) => {
      this.updateSlider(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name);
      this.sendMixpanelEvent(ActionDetails.INFLUENCER_REJECTED_REQUEST, this.campaign.campaign.id, this.campaign.campaign.name, true);
      if (!this.isFirstTime) {
        this.back();
      }
    }, (error) => {
      if (this.isFirstTime) {
        return this.goToAllSetPage(false, null, false);
      } else {
        this.back();
      }
      // Report to Sentry
      Sentry.captureException(error);
    });
  }

  onDismissCampaignErrorModal() {
    this.errorType = null;
  }

  requestNewInvitation() {
    const currentInfluencer = this.userService.getInfluencerInfo();
    if (currentInfluencer) {
      this.influencerService.requestNewCampaignInvitation(currentInfluencer.id, this.campaignInfluencerId, RequestInfluencerType.CAMPAIGN_INVITATION)
        .subscribe(res => {
          this.modalService.close();
          this.router.navigate(['campaigns']);
        }, (err) => {
          this.modalService.close();
          this.router.navigate(['campaigns']);
        });
    }
  }

  tryAgainHandler(errorType) {
    if (!errorType) {
      return null;
    }
    if (errorType === InfluencerRequestError.CAMPAIGN_INVITATION_DELETE) {
      return this.requestNewInvitation();
    } else {
      return this.reloadPlatform();
    }
  }

  reloadPlatform() {
    this.modalService.close();
    return document.location.reload();
  }

  isShowRetryButton(errorType: InfluencerRequestError) {
    return errorType === InfluencerRequestError.RETRIEVE_CAMPAIGN_INFO_FAIL;
  }

  back() {
    return this.location.back();
  }

  public isHideBottomBar() {
    return this.selectedTab === NewCampaignTabs.CHAT;
  }

  isShowButtonAccept() {
    return AppSettings.isActiveNewCampaignFlow() && this.campaignInfluencer
      && `${this.campaignInfluencer.status}`.toLocaleLowerCase() !== CampaignInfluencerStatus.ACTIVE.toLocaleLowerCase()
      && `${this.campaignInfluencer.status}`.toLocaleLowerCase() !== CampaignInfluencerStatus.ARCHIVED.toLocaleLowerCase();
  }

  isShowButtonDecline() {
    return AppSettings.isActiveNewCampaignFlow() && this.campaignInfluencer
      && `${this.campaignInfluencer.status}`.toLocaleLowerCase() !== CampaignInfluencerStatus.ACTIVE.toLocaleLowerCase()
      && `${this.campaignInfluencer.status}`.toLocaleLowerCase() !== CampaignInfluencerStatus.ARCHIVED.toLocaleLowerCase();
  }

  isEnableExportButton() {
    return this.campaignInfluencer && `${this.campaignInfluencer.status}`.toLocaleLowerCase() !== CampaignInfluencerStatus.NEW.toLocaleLowerCase();
  }

  isActivatedAdvertiserChat() {
    return !AppSettings.isDisableChat();
  }

  public exportPDF() {
    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
    this.pdfViewerService.generateCampaignPdf(this.campaignInfluencerId).subscribe();
  }

  public closeNotification() {
    this.modalService.close();
  }

  private calculateCampaignStatus(status) {
    const statusUppercase = `${status}`.toUpperCase();
    if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name
      || statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INTERESTED.name) {
      return CampaignInfluencerStatus.NEW;
    } else if (statusUppercase === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
      return CampaignInfluencerStatus.DELETE;
    } else {
      return CampaignInfluencerStatus.ACTIVE;
    }
  }

  private updateInfluencerCampaignInvitation(status) {
    return new Promise((resolve, reject) => {
      if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name) {
        this.influencerService.acceptCampaignInvitation(this.campaignId, this.currentInfluencer.id)
        .subscribe((res: any) => {
            resolve(res);
          }, (error) => {
            reject(error);
          }
        );
      } else if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
        this.influencerService.declineCampaignInvitation(this.campaignId, this.currentInfluencer.id)
        .subscribe((res: any) => {
            resolve(res);
          }, (error) => {
            reject(error);
          }
        );
      }
    });
  }

  private goToAllSetPage(onAcceptCampaignInvitation: boolean, acceptionResult?, declineResult?) {
    let queryParams;
    if (onAcceptCampaignInvitation) {
      queryParams = {
        requestType: 'campaign_invitation',
        campaignInfluencerId: this.campaignInfluencerId,
        acceptionResult,
        campaignId: this.campaignId,
        isNewCampaign: this.isNewCampaign,
        inviteToken: this.inviteToken
      };
    } else {
      queryParams = {
        requestType: 'campaign_invitation',
        campaignInfluencerId: this.campaignInfluencerId,
        declineResult,
        campaignId: this.campaignId,
        isNewCampaign: this.isNewCampaign,
        isDeclined: true,
        inviteToken: this.inviteToken
      };
    }
    return this.router.navigate(['user', 'all-set'], {
      queryParams
    });
  }

  public setSelectedTab(tab: NewCampaignTabs) {
    this.selectedTab = tab;
  }

  public setCampaingSelected() {
    this.selectedTab = NewCampaignTabs.CAMPAIGN;
  }

  public setChatTabSelected() {
    this.selectedTab = NewCampaignTabs.CHAT;
    // Should load actual message here
    const currentInfluencer = this.userService.getInfluencerInfo();
    this.loadInfluencerConversation(this.campaign.campaign.companyId, currentInfluencer.id);
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
      id: TargetType.OPEN_CONTACT_TAB,
      name: TargetType.OPEN_CONTACT_TAB,
      type: TargetType.OPEN_CONTACT_TAB
    }, {
      source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP
    }, undefined, null);
  }

  public isCampaignTabSelected() {
    return !!this.selectedTab && this.selectedTab === NewCampaignTabs.CAMPAIGN;
  }

  public isChatTabSelected() {
    return !!this.selectedTab && this.selectedTab === NewCampaignTabs.CHAT;
  }

  get showBottomBar() {
    if (this.inviteToken || this.onMobile) {
      return false;
    }
    return this.selectedTab === NewCampaignTabs.CAMPAIGN;
  }

  get onMobile() {
    return this.deviceService.isMobile();
  }

  get isLandingPageMode() {
    return this.inviteToken;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-new.component.ts